import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { env } from "../../../../../env";
import axiosInstance from "../../../../globalInspector/axiosInstance";
import CommonToast from "../../../../../components/_utils/CommonToast";
import ICONS from "../../../../../assets/Icons";

const baseUrl = env.REACT_APP_BASE_URL;

export const getSpecificRole = createAsyncThunk(
  "getSpecificRole",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/roles/${id}`, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(undefined);
    }
  },
);
export const getRoles = createAsyncThunk(
  "getRoles",
  async (
    { page_no, page_size, search_string, entity_id, sort_by },
    { rejectWithValue },
  ) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/roles`, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
        params: {
          page_no: page_no,
          page_size: page_size,
          search_string,
          entity_id,
          sort_by,
        },
      });
      return response.data;
    } catch (error) {
      CommonToast({
        text: error.response.data.error,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(error);
    }
  },
);
const rolesSlice = createSlice({
  name: "roles",
  initialState: {
    specificRoleData: null,
    specificRoleLoading: false,
    specificRoleError: null,
    allRolesData: [],
    allRolesIsLoading: true,
    allRolesFailData: null,
  },
  extraReducers: (builder) => {
    builder.addCase(getSpecificRole.pending, (state, action) => {
      state.specificRoleLoading = true;
    });
    builder.addCase(getSpecificRole.fulfilled, (state, action) => {
      state.specificRoleLoading = false;
      state.specificRoleData = action.payload;
    });
    builder.addCase(getSpecificRole.rejected, (state, action) => {
      state.specificRoleLoading = false;
      state.specificRoleError = true;
      state.specificRoleData = null;
    });
    builder.addCase(getRoles.fulfilled, (state, action) => {
      state.allRolesData = action.payload;
      state.allRolesIsLoading = false;
    });
    builder.addCase(getRoles.rejected, (state, action) => {
      state.allRolesData = null;
      state.allRolesIsLoading = false;
      state.allRolesFailData = action.payload;
    });
    builder.addCase(getRoles.pending, (state, action) => {
      state.allRolesIsLoading = true;
    });
  },
});

export default rolesSlice.reducer;
